<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Status Marker</h1>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Waiting</h2>
    <h3>Enabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [menuItems]="menuItemDone"
        [status]="'waiting'">
      </ui-platform-status-marker>
    </div>

    <h3>Disabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [disabled]="true"
        [status]="'waiting'">
      </ui-platform-status-marker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>In Progress</h2>
    <h3>Enabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [menuItems]="menuItemInteractionNeededVerified"
        [status]="'in_progress'">
      </ui-platform-status-marker>
    </div>

    <h3>Disabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [disabled]="true"
        [status]="'in_progress'">
      </ui-platform-status-marker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Done</h2>
    <h3>Enabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [menuItems]="menuItemDone"
        [status]="'done'">
      </ui-platform-status-marker>
    </div>

    <h3>Disabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [disabled]="true"
        [status]="'done'">
      </ui-platform-status-marker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Verification</h2>
    <h3>Enabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [menuItems]="menuItemDone"
        [status]="'verification'">
      </ui-platform-status-marker>
    </div>

    <h3>Disabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [disabled]="true"
        [status]="'verification'">
      </ui-platform-status-marker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Interaction Needed</h2>
    <h3>Enabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [menuItems]="menuItemDone"
        [status]="'interaction_needed'">
      </ui-platform-status-marker>
    </div>

    <h3>Disabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [disabled]="true"
        [status]="'interaction_needed'">
      </ui-platform-status-marker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Verified</h2>
    <h3>Enabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [menuItems]="menuItemDone"
        [status]="'verified'">
      </ui-platform-status-marker>
    </div>

    <h3>Disabled</h3>
    <p>Add description</p>
    <div class="button-row">
      <ui-platform-status-marker
        [disabled]="true"
        [status]="'verified'">
      </ui-platform-status-marker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Template usage</h2>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
    <p>Menu items for menu:</p>
    <pre>{{ menuItemsSample }}</pre>
  </div>
</div>
